import type { MatchHistoryRadarItem } from '@pickpro/contracts';

const games = [
  { id: '0192f3a1-7c20-7b1e-9c4a-2f5b8d3e6a03', at: '2026-07-05T21:30:00.000Z', value: 12 },
  { id: '0192f3a1-7c20-7b1e-9c4a-2f5b8d3e6a04', at: '2026-07-12T21:30:00.000Z', value: 8 },
  { id: '0192f3a1-7c20-7b1e-9c4a-2f5b8d3e6a05', at: '2026-07-19T21:30:00.000Z', value: 11 },
  { id: '0192f3a1-7c20-7b1e-9c4a-2f5b8d3e6a06', at: '2026-07-26T21:30:00.000Z', value: 9 },
  { id: '0192f3a1-7c20-7b1e-9c4a-2f5b8d3e6a07', at: '2026-08-02T21:30:00.000Z', value: 13 },
  { id: '0192f3a1-7c20-7b1e-9c4a-2f5b8d3e6a08', at: '2026-08-09T21:30:00.000Z', value: 7 },
  { id: '0192f3a1-7c20-7b1e-9c4a-2f5b8d3e6a09', at: '2026-08-16T21:30:00.000Z', value: 10 },
  { id: '0192f3a1-7c20-7b1e-9c4a-2f5b8d3e6a0a', at: '2026-08-23T21:30:00.000Z', value: 12 },
  { id: '0192f3a1-7c20-7b1e-9c4a-2f5b8d3e6a0b', at: '2026-08-30T21:30:00.000Z', value: 6 },
  { id: '0192f3a1-7c20-7b1e-9c4a-2f5b8d3e6a0c', at: '2026-09-06T21:30:00.000Z', value: 11 },
] as const;

const opponents = [
  'Botafogo',
  'Corinthians',
  'Grêmio',
  'Internacional',
  'São Paulo',
  'Atlético Mineiro',
  'Fluminense',
  'Cruzeiro',
  'Vasco da Gama',
  'Bahia',
] as const;

export const landingSampleItem: MatchHistoryRadarItem = {
  id: 'landing-sample-corners',
  scope: 'match',
  source: 'history',
  fixtureId: '0192f3a1-7c20-7b1e-9c4a-2f5b8d3e6a01',
  date: '2026-09-12',
  startsAt: '2026-09-12T19:00:00.000Z',
  competitionId: '0192f3a1-7c20-7b1e-9c4a-2f5b8d3e6a02',
  competition: 'Brasileirão Série A',
  competitionLogoUrl: null,
  homeName: 'Flamengo',
  awayName: 'Palmeiras',
  homeLogoUrl: null,
  awayLogoUrl: null,
  market: 'corners',
  period: 'full',
  side: 'over',
  line: 9.5,
  probability: 0.6,
  pushProbability: 0,
  price: 1.85,
  fairOdds: 1.67,
  expectedValue: 0.11,
  bookmaker: 'Betano',
  observedAt: '2026-09-12T15:40:00.000Z',
  oddsAt: '2026-09-12T15:40:00.000Z',
  hits: 6,
  known: 10,
  total: 10,
  average: 9.9,
  history: games.map((game, index) => ({
    fixtureId: game.id,
    startsAt: game.at,
    value: game.value,
    opponentName: opponents[index]!,
    teamSide: index % 2 === 0 ? 'home' : 'away',
  })),
};
